var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLibrary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m245.002 10.998c-24.518 0-48.188 3.618-70.524 10.321l-149.967 127.756c-15.699 32.312-24.511 68.588-24.511 106.925 0 39.298 9.267 76.427 25.713 109.344l52.755 70.336c32.559 30.191 73.331 51.641 118.599 60.621l115.532-5.046v.297c102.435-29.342 177.405-123.689 177.405-235.552 0-135.311-109.691-245.002-245.002-245.002z",
    fill: "#1c2e7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m476.59 68.356h-389.102c-8.411 7.068-16.327 14.702-23.717 22.823l-39.86 59.197c-12.296 25.695-20.259 53.859-22.911 83.557v44.134c3.02 33.824 12.901 65.671 28.262 94.132h482.738v-268.433c0-19.525-15.885-35.41-35.41-35.41z",
    fill: "#167cc1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.089 319.534 3.126-251.177h-42.727c-8.411 7.068-16.327 14.702-23.716 22.823l-39.86 59.197c-12.297 25.694-20.26 53.858-22.912 83.556v44.134c3.02 33.824 12.901 65.671 28.262 94.132h97.827v-2.074c-23.217-30.447 0-50.591 0-50.591z",
    fill: "#0e62a8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.554 195.426c-53.504-65.17-112.544-54.343-136.18-46.076-.188.389-.373.78-.559 1.17v210.961c1.731 3.622 3.546 7.197 5.447 10.718h459.923v-54.731c-25.409-.602-53.337-14.359-86.04-47.062-69.486-69.487-126.793 66.066-242.591-74.98z",
    fill: "#9bd8f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.089 319.534 1.918-154.078c-43.584-31.074-85.593-22.765-104.632-16.106-.188.389-.373.78-.559 1.17v210.961c1.731 3.622 3.546 7.197 5.447 10.718h97.827v-2.074c-23.218-30.447-.001-50.591-.001-50.591z",
    fill: "#73c3f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m476.59 91.171h-412.855c-16.037 17.626-29.531 37.603-39.92 59.348v1.1c23.257-8.287 82.812-19.804 136.739 45.881 115.798 141.046 173.105 5.493 242.591 74.98 32.703 32.703 60.63 46.46 86.04 47.062v-215.776c0-6.827-5.768-12.595-12.595-12.595z",
    fill: "#e9efff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.815 150.52v1.1c18.765-6.686 61.162-15.465 105.165 15.892l.95-76.34h-66.195c-16.036 17.625-29.531 37.602-39.92 59.348z",
    fill: "#d3dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.002 501.002c23.814 0 46.829-3.411 68.597-9.748-1.298-3.526-2.341-7.466-2.929-11.852l-5.751-42.91h-96.839l-5.751 42.91c-.891 6.644-2.803 12.262-5.077 16.933 15.446 3.053 31.409 4.667 47.75 4.667z",
    fill: "#d3dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.138 497.403 2.756-20.565c1.715-12.794 12.631-22.345 25.54-22.345h42.898l-2.412-18h-96.84l-5.751 42.91c-.891 6.644-2.803 12.262-5.077 16.934 12.458 2.461 25.256 3.969 38.314 4.468.217-1.107.415-2.233.572-3.402z",
    fill: "#bec8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.76 51.694h30.062v-17.021c-10.451 4.975-20.491 10.673-30.062 17.021z",
    fill: "#4fabf7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.53 98.283v164.595h82.292v-185.361h-62.639c-6.946 6.533-13.507 13.468-19.653 20.766z",
    fill: "#4fabf7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.676 77.517h-21.493c-6.946 6.533-13.507 13.468-19.653 20.766v164.595h41.146z",
    fill: "#1e9ef4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.53 288.701v18.1c0 7.003 5.73 12.733 12.733 12.733h56.826c7.003 0 12.733-5.73 12.733-12.733v-18.1z",
    fill: "#4fabf7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.676 301.862v-13.161h-41.146v18.1c0 7.003 5.73 12.733 12.733 12.733h45.936c-9.652-.086-17.523-8.001-17.523-17.672z",
    fill: "#1e9ef4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.114 77.517h82.292v185.362h-82.292z",
    fill: "#ff4155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.114 77.517h41.146v185.362h-41.146z",
    fill: "#e80054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304.406 51.694v-18.1c0-7.003-5.73-12.733-12.733-12.733h-56.826c-7.003 0-12.733 5.73-12.733 12.733v18.1z",
    fill: "#ff4155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.26 37.158c0-7.305 4.491-13.611 10.847-16.297h-39.26c-7.003 0-12.733 5.73-12.733 12.733v18.1h41.146z",
    fill: "#e80054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.114 288.701v18.1c0 7.003 5.73 12.733 12.733 12.733h56.826c7.003 0 12.733-5.73 12.733-12.733v-18.1z",
    fill: "#ff4155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.26 301.862v-13.161h-41.146v18.1c0 7.003 5.73 12.733 12.733 12.733h45.936c-9.652-.086-17.523-8.001-17.523-17.672z",
    fill: "#e80054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.822 64.606h82.292v211.184h-82.292z",
    fill: "#ffb332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.822 64.606h41.146v211.184h-41.146z",
    fill: "#ff9100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.792 61.908h82.292v211.184h-82.292z",
    fill: "#38c674",
    transform: "matrix(.966 -.259 .259 .966 -30.406 104.042)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339.496 67.251h41.005v211.184h-41.005z",
    fill: "#24b55e",
    transform: "matrix(.966 -.259 .259 .966 -32.469 99.065)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.634 438.567h394.956c19.525 0 35.41-15.885 35.41-35.41v-33.033h-483.832c13.664 25.909 31.831 49.07 53.466 68.443z",
    fill: "#e9efff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.089 370.124h-98.921c13.664 25.908 31.831 49.069 53.466 68.443h63.451c-18.794-10.18-17.996-34.221-17.996-34.221z",
    fill: "#d3dcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.089 370.124h-98.921c13.664 25.908 31.831 49.069 53.466 68.443h63.451c-18.794-10.18-17.996-34.221-17.996-34.221z",
    fill: "#d3dcfb"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.5,
    cy: 404.346,
    fill: "#bec8f7",
    rx: 15.265,
    ry: 15.265,
    transform: "matrix(.161 -.987 .987 .161 -183.857 592.423)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m98.676 235.273c-4.296 0-7.778-3.482-7.778-7.778v-114.596c0-4.296 3.482-7.778 7.778-7.778s7.778 3.482 7.778 7.778v114.596c0 4.297-3.483 7.778-7.778 7.778z",
    fill: "#73c3f9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m263.26 235.273c-4.296 0-7.778-3.482-7.778-7.778v-114.596c0-4.296 3.482-7.778 7.778-7.778s7.778 3.482 7.778 7.778v114.596c0 4.297-3.483 7.778-7.778 7.778z",
    fill: "#ff7186"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m194.497 100.685h-27.057c-4.296 0-7.778-3.482-7.778-7.778s3.482-7.778 7.778-7.778h27.057c4.296 0 7.778 3.482 7.778 7.778s-3.483 7.778-7.778 7.778z",
    fill: "#fcf2c8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m189.059 126.833h-16.182c-4.296 0-7.778-3.482-7.778-7.778s3.482-7.778 7.778-7.778h16.182c4.296 0 7.778 3.482 7.778 7.778 0 4.297-3.483 7.778-7.778 7.778z",
    fill: "#fcf2c8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m346.861 104.125c-3.434 0-6.577-2.292-7.508-5.767-1.112-4.149 1.35-8.414 5.5-9.526l26.135-7.003c4.151-1.117 8.414 1.35 9.526 5.499s-1.35 8.414-5.5 9.526l-26.135 7.003c-.674.181-1.352.268-2.018.268z",
    fill: "#e9efff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m358.881 127.975c-3.434 0-6.576-2.292-7.508-5.767-1.112-4.149 1.35-8.414 5.499-9.526l15.63-4.189c4.147-1.115 8.414 1.35 9.526 5.499s-1.35 8.414-5.499 9.526l-15.63 4.189c-.673.182-1.351.268-2.018.268z",
    fill: "#e9efff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m57.53 261.465h82.292v28.649h-82.292z",
    fill: "#73c3f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.53 261.465h41.146v28.649h-41.146z",
    fill: "#4fabf7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.822 78.93v-28.649h-27.915c-12.972 8.41-25.103 18.007-36.228 28.649z",
    fill: "#73c3f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.676 59.501c-8.06 6.009-15.746 12.493-22.997 19.429h22.997z",
    fill: "#4fabf7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.114 261.465h82.292v28.649h-82.292z",
    fill: "#ff7186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.114 261.465h41.146v28.649h-41.146z",
    fill: "#ff4155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.114 50.281h82.292v28.649h-82.292z",
    fill: "#ff7186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.114 50.281h41.146v28.649h-41.146z",
    fill: "#ff4155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.822 274.225v32.575c0 7.003 5.73 12.733 12.733 12.733h56.826c7.003 0 12.733-5.73 12.733-12.733v-32.575z",
    fill: "#ffdd40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.968 301.862v-27.636h-41.146v32.575c0 7.003 5.73 12.733 12.733 12.733h45.936c-9.652-.086-17.523-8.001-17.523-17.672z",
    fill: "#ffb332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.822 66.17h82.292v-32.575c0-7.003-5.73-12.733-12.733-12.733h-33.367c-12.508 3.664-24.602 8.293-36.193 13.811v31.497z",
    fill: "#ffdd40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.968 37.158c0-7.305 4.491-13.611 10.848-16.297h-15.801c-12.508 3.664-24.602 8.293-36.193 13.811v31.498h41.146z",
    fill: "#ffb332"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m446.366 256.437-79.488 21.298 8.671 32.362c1.812 6.765 8.83 10.816 15.594 9.004l54.89-14.708c6.764-1.813 10.816-8.83 9.004-15.595z",
    fill: "#49d88b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m438.784 305.327c-11.367 3.046-23.052-3.7-26.098-15.068l-6.199-23.137-39.609 10.613 8.671 32.362c1.813 6.765 8.83 10.816 15.595 9.004l54.89-14.708c1.662-.445 3.157-1.208 4.445-2.2z",
    fill: "#38c674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.51 78.563 79.488-21.299-8.671-32.362c-1.813-6.764-8.831-10.816-15.595-9.003l-54.89 14.708c-6.765 1.813-10.816 8.83-9.004 15.595z",
    fill: "#49d88b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.43 42.989c-2.49-9.292 1.565-18.792 9.336-23.617l-41.924 11.234c-6.765 1.813-10.816 8.83-9.004 15.595l8.672 32.362 39.608-10.613z",
    fill: "#38c674"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.8c0629dd.svg";
export { ForwardRef as ReactComponent };